import { render, staticRenderFns } from "./Horarios.vue?vue&type=template&id=612f4660&"
import script from "./Horarios.vue?vue&type=script&lang=js&"
export * from "./Horarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports